import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import AssignCallAuditorDialog, {
  AssignCallAuditorUniqueProps,
} from '../AssignCallAuditorDialog';

const { useDialogForContext, useDialog: useAssignCallAuditorDialog } =
  getDialogHooks<AssignCallAuditorUniqueProps, boolean>(
    AssignCallAuditorDialog
  );
export const useAssignCallAuditorDialogForContext = useDialogForContext;
export default useAssignCallAuditorDialog;
